<template>
    <div class="cart-steps" id="cart-steps">
        <Configure3DModelScaleSlider v-if="current3DFile &&  typeof currentCartItem.scale === 'number' && currentStep === 'configure'"></Configure3DModelScaleSlider>
        <div class="columns">
            <div class="column is-one-third step"
                 :class="{'is-completed': ['upload', 'configure', 'cart'].includes(currentStep)}">
                <strong class="step__number">1. </strong><span> {{ $t('checkout.steps.choose3DFile') }}</span>
            </div>
            <div class="column is-one-third step"
                 :class="{'is-completed': ['configure', 'cart'].includes(currentStep)}">
                <strong class="step__number">2. </strong><span> {{ $t('checkout.steps.choosePrintMode') }}</span>
            </div>
            <div class="column is-one-third step"
                 :class="{'is-completed': ['cart'].includes(currentStep)}">
                <strong class="step__number">3. </strong><span> {{ $t('checkout.steps.checkout') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Configure3DModelScaleSlider from "../checkout/Configure3DModelScaleSlider";
    import {mapGetters} from "vuex";
    import {orderProcess} from "../../store/constants/order-process";

    export default {
        name: "Steps",
        data() {
            return {
                orderProcess
            }
        },
        components: {
            Configure3DModelScaleSlider
        },
        computed: {
            ...mapGetters(['currentOrderProcessStep','current3DFile', 'currentCartItem']),
            currentStep() {
                if ([orderProcess.STEPS.NO_ORDER_ONGOING, orderProcess.STEPS.FILE_UPLOAD, orderProcess.STEPS.ORDER_COMPLETED].includes(this.currentOrderProcessStep)) {
                    return "upload"
                } else if ([orderProcess.STEPS.CONFIGURE_MODEL].includes(this.currentOrderProcessStep)) {
                    return "configure"
                } else {
                    return "cart"
                }
            }
        }

    }
</script>

<style scoped>

</style>